export const environment = {
  production: false,
  brandName: "75F",
  caretakerUrl: "https://caretaker.qa.service.75f.io/api/v1",
  publicUrl: "/reports/public",
  deploymentConfig: {
    multiRegion: true,
    defaultRegion: 1,
    regions: {
      1: {
        regionName: "North America" ,
        endpoints: {
          siloUrl: "https://silo.qa.service.75f.io",
          buildingAnalyticsUrl: "https://bas.qa.service.75f.io",
          reportingUrl: "https://auto-cx-qa.75f.io",
          fddUrl: "https://fdd.qa.service.75f.io"
        }
      },
      2: {
        regionName: "Europe" ,
        endpoints: {
          siloUrl: "https://silo.qa-eu.service.75f.io",
          buildingAnalyticsUrl: "https://bas.qa-eu.service.75f.io",
          reportingUrl: "https://auto-cx-qa.75f.io",
          fddUrl: "https://fdd.qa-eu.service.75f.io"
        }
      }
    }
  }
};
